(function () {
  function initCarousels() {
    document.querySelectorAll('.kph-track-wrap').forEach(function (wrap) {
      var track = wrap.querySelector('.kph-track');
      var prev = wrap.querySelector('.kph-prev');
      var next = wrap.querySelector('.kph-next');
      if (!track) return;

      function step() {
        var item = track.querySelector('.kph-item');
        return item ? (item.offsetWidth + 22) * 2 : 320;
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
      }
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function initModal() {
    var modal = document.getElementById('koji-collab-modal');
    if (!modal) return;
    if (modal.parentNode !== document.body) document.body.appendChild(modal);
    var closeBtn = modal.querySelector('.koji-collab-close');
    var lastTrigger = null;

    function open(trigger) {
      lastTrigger = trigger;
      modal.classList.add('is-active');
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      modal.classList.remove('is-active');
      if (lastTrigger) lastTrigger.focus();
    }

    document.querySelectorAll('.koji-collab-trigger').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); open(btn); });
    });
    if (closeBtn) closeBtn.addEventListener('click', function (e) { e.preventDefault(); close(); });
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-active')) close();
    });
  }

  function init() { initCarousels(); initModal(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();